import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "grayBox" }
const _hoisted_3 = {
  class: "bold",
  style: {"font-size":"20px"}
}
const _hoisted_4 = { class: "red" }
const _hoisted_5 = { class: "red" }
const _hoisted_6 = { class: "box" }
const _hoisted_7 = { class: "tableList mgB15" }
const _hoisted_8 = ["rowspan"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "blue"
}
const _hoisted_13 = {
  key: 0,
  class: "blue"
}
const _hoisted_14 = { class: "conBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BR = _resolveComponent("BR")!
  const _component_JSDCustView = _resolveComponent("JSDCustView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("p", null, "휴대폰 번호 (대표번호)가 동일한 연락처를 하나의 연락처 (대표 연락처)로 병합합니다. ", -1)),
        _createElementVNode("p", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString($data.ui.TOT_CNTA), 1),
          _cache[4] || (_cache[4] = _createTextVNode("개의 연락처가 ", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString($data.ui.MERGE_CNTA_CNT), 1),
          _cache[5] || (_cache[5] = _createTextVNode("개의 연락처로 합쳐집니다. ", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "blueBtn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.check_all('on')))
      }, "전체 선택"),
      _cache[8] || (_cache[8] = _createTextVNode("  ", -1)),
      _createElementVNode("button", {
        class: "blueBtn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.check_all('off')))
      }, "전체 해제"),
      _createVNode(_component_BR),
      _createVNode(_component_BR),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.merge_list, (r) => {
        return (_openBlock(), _createElementBlock("table", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("tr", null, [
            _createElementVNode("th", {
              style: {"width":"5%"},
              align: "center"
            }),
            _createElementVNode("th", { style: {"width":"10%"} }, "대표연락처"),
            _createElementVNode("th", { style: {"width":"15%"} }, "이름"),
            _createElementVNode("th", { style: {"width":"15%"} }, "연락처"),
            _createElementVNode("th", { style: {"width":"25%"} }, "그룹"),
            _createElementVNode("th", { style: {"width":"25%"} }, "도서")
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.LIST, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              (index === 0)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    rowspan: r.PHONE_CNT
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((r.IS_CHECK) = $event),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => {$options.info_check();})
                    }, null, 40, _hoisted_9), [
                      [_vModelCheckbox, r.IS_CHECK]
                    ])
                  ], 8, _hoisted_8))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: _normalizeClass([item.IS_RPRS ? 'blueBtn': 'whiteBtn']),
                  onClick: ($event: any) => {$options.change_rprs(r, item.CUST_NO);}
                }, _toDisplayString(item.IS_RPRS === true ? '대표연락처' : '연락처'), 11, _hoisted_10)
              ]),
              _createElementVNode("td", {
                onClick: ($event: any) => {$options.cust_layer_view(item);},
                style: {"cursor":"pointer"}
              }, _toDisplayString(item.CUST_NM) + "(" + _toDisplayString(item.RTNG_CD) + "/" + _toDisplayString(item.CUST_AGE) + "/" + _toDisplayString(item.IS_SEX == '1' ? '남' : '여') + ")", 9, _hoisted_11),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(item.PHONE_CNO) + " ", 1),
                (item.PHONE_CNT > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(+" + _toDisplayString(item.PHONE_CNT) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(r.GROUP_NMS), 1),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(r.BOOK_TITLE) + " ", 1),
                (r.JSD_BOOK_CNT > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(+" + _toDisplayString(r.JSD_BOOK_CNT) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 256))
        ]))
      }), 256)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => {$options.merge_proc();})
        }, "선택한 중복 연락처 병합 ")
      ]),
      _createVNode(_component_JSDCustView, {
        ref: "JSDCustView",
        cust_no: $data.ui.cust_layer.cust_no
      }, null, 8, ["cust_no"])
    ])
  ], 64))
}